(function() { window.GUID_65d28884_af49_45b1_bd02_caf5ab563146 = { getGuid: function() { return "65d28884-af49-45b1-bd02-caf5ab563146"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScrollListener {
            constructor(jqueryElement) {
                this.timerReset = null;
                this.lastScroll = 0;
                this.lastDirection = "";
                let me = this;
                me.$scrolledElement = jqueryElement;
                me.$scrolledElement.offon('scroll.scrolllistener', function (e) {
                    if (me.OnScrollChange != null) {
                        me.OnScrollChange();
                    }
                });
                me.$scrolledElement.offon('touchmove.scrolllistener', function (e) {
                    if (me.OnScrollChange != null) {
                        me.OnScrollChange();
                    }
                });
            }
            scrollChange() {
                if (this.OnScrollChange != null) {
                    this.OnScrollChange();
                }
                this.testScrollDirectionChange();
            }
            testScrollDirectionChange() {
                let me = this;
                clearTimeout(me.timerReset);
                me.timerReset = setTimeout(function () {
                    let currentScroll = me.$scrolledElement.scrollTop();
                    let currentDirection = me.lastDirection;
                    if (currentScroll > me.lastScroll && currentScroll > 50) {
                        currentDirection = "down";
                        if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                            me.OnScrollDirectionChange.call(this, "down");
                        }
                    }
                    else if (currentScroll < me.lastScroll) {
                        currentDirection = "up";
                        if (me.OnScrollDirectionChange != null && currentDirection != me.lastDirection) {
                            me.OnScrollDirectionChange.call(this, "up");
                        }
                    }
                    me.lastScroll = currentScroll;
                    me.lastDirection = currentDirection;
                }, 0);
            }
        }
        Controls.ScrollListener = ScrollListener;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=scroll-listener.pre.js.map
